
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-analysis/[slug]",
      function () {
        return require("private-next-pages/industry-analysis/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-analysis/[slug]"])
      });
    }
  